import React, { forwardRef } from 'react';
import { RadioGroup as RadioGroupBase, RadioGroupProps } from '@mui/material';

type Props = RadioGroupProps & {
  disabled?: boolean;
};

const RadioGroup = forwardRef<HTMLDivElement, Props>(
  ({ disabled, children, ...props }, ref) => (
    <RadioGroupBase ref={ref} {...props}>
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          const childDisabled = (child.props as { disabled?: boolean })
            .disabled;
          return React.cloneElement(
            child as React.ReactElement<{ disabled?: boolean }>,
            {
              disabled: Boolean(disabled || childDisabled),
            },
          );
        }
        return child;
      })}
    </RadioGroupBase>
  ),
);

export default RadioGroup;
